import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177f1312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sharing Invitation"),
  /*#__PURE__*/_createElementVNode("p", null, "Code with Friends")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "count" }, "10% off"),
  /*#__PURE__*/_createElementVNode("span", null, "on Tesla Exclusive loan!")
], -1))
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "count" }, "9", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "折", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "count" }, "10", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "percent" }, "%", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "off", -1))
const _hoisted_15 = { class: "detail" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "*1", -1))
const _hoisted_17 = { class: "activity-inviteCode" }
const _hoisted_18 = { class: "activity-inviteCode-use" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "activity-inviteCode-content" }
const _hoisted_21 = { class: "activity-inviteCode-desc" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "activity-inviteCode-wrapper" }
const _hoisted_24 = { class: "activity-tips" }
const _hoisted_25 = { class: "activity-extra" }
const _hoisted_26 = { class: "guide" }
const _hoisted_27 = { class: "guide-wrapper" }
const _hoisted_28 = { class: "guide-step" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_31 = { class: "guide-step" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "guide-step" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_36 = { class: "guide-step" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LangVue = _resolveComponent("LangVue")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_common_title = _resolveComponent("common-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["banner", { eng: _ctx.isEng }])
    }, [
      _createElementVNode("img", {
        src: require(`@/assets/images/inviteCodePersonal/logo${_ctx.isEng ? '_en' : ''}.png`),
        alt: "",
        class: "logo"
      }, null, 8, _hoisted_2),
      _createVNode(_component_LangVue, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('好友赠你贷款邀请码')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('Tesla专享贷款实际年利率打')), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('9折')), 1)
          ])
        ]),
        en: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('Tesla贷款减息券')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LangVue, null, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          en: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_15, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('活动期间，首次申请Tesla贷款并于申请流程中填入贷款邀请码，获批后可得9折Tesla贷款减息券')), 1),
          _hoisted_16
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('。(领取后30日有效，提款满10万港币可用)')), 1)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["activity", { eng: _ctx.isEng }])
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodeShare/use_${_ctx.lang}.png`),
            alt: ""
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.$t('输入好友贷款邀请码')), 1),
            _hoisted_22,
            _createTextVNode(_toDisplayString(_ctx.$t('领9折Tesla贷款减息券')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.inviteCode), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_24, [
        _createTextVNode(_toDisplayString(_ctx.$t('阁下首次申请Tesla贷款时填入以上贷款邀请码即代表阁下同意受本')), 1),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkProto && _ctx.checkProto(...args)))
        }, _toDisplayString(_ctx.$t('条款及细则')), 1),
        _createTextVNode(_toDisplayString(_ctx.$t('约束。请细阅有关条款及细则。')), 1)
      ]),
      _createVNode(_component_t_button, {
        "data-clipboard-text": _ctx.inviteCode,
        class: "activity-copy",
        theme: "primary",
        text: _ctx.$t('复制'),
        onClick: _ctx.handleClick
      }, null, 8, ["data-clipboard-text", "text", "onClick"]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('Tesla专享贷款适用于Tesla车主（有车辆识别号）及已预订Tesla客户（有Tesla订单号）。')), 1)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_common_title, {
        title: _ctx.$t('领券攻略')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodeShare/step1_${_ctx.lang}.png`),
            alt: ""
          }, null, 8, _hoisted_29),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('于应用商店搜索并下载Fusion Bank APP并完成开户')), 1),
          _createElementVNode("p", null, [
            _hoisted_30,
            _createTextVNode(_toDisplayString(_ctx.$t('不是在开户页面输入邀请码喔！请在步骤3输入')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodeShare/step2_${_ctx.lang}.png`),
            alt: ""
          }, null, 8, _hoisted_32),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('APP首页点击“贷款”，选择“Tesla专享贷款”产品')), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodeShare/step3_${_ctx.lang}.png`),
            alt: ""
          }, null, 8, _hoisted_34),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('如果暂未有申请资格，请先登记获得资格。成功登记后即可开始贷款流程')), 1),
          _createElementVNode("p", null, [
            _hoisted_35,
            _createTextVNode(_toDisplayString(_ctx.$t('记得填入邀请码喔')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("img", {
            src: require(`@/assets/images/inviteCodeShare/step4_${_ctx.lang}.png`),
            alt: ""
          }, null, 8, _hoisted_37),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('提交申请，获批后可得Tesla贷款9折减息券')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_common_title, {
        title: _ctx.$t('备注')
      }, null, 8, ["title"]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(
            '*1.被邀请人在活动期间首次申请Tesla专享贷款并填入邀请码且成功通过审批后可获9折减息券。被邀请人活动期间仅能获得1次9折减息券。',
          )), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('优惠数量有限，先到先得')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('受活动条款及细则约束')), 1)
    ])
  ]))
}